export const VILCAP_PROGRAMS_PAGE = "https://vilcap.com/programs";

const LEVEL_INFO = 1;
const COMPANY_INFO = 2;
const TEAM_INFO = 3;

export const USER_SUBMISSION_INFO = [LEVEL_INFO, COMPANY_INFO, TEAM_INFO];
